import React, {  useState } from "react";
import "./SIdebar.css";

// import Button from 'react-bootstrap/Button';
// import Offcanvas from 'react-bootstrap/Offcanvas';
import Logo from "../../images/logo.png";
import Logosm from "../../images/logo-sm.png";
import Menu from "../../images/menu-bar.png";
import SearchIcon from "../../images/search.png";
import CTQ from "../../images/CTQ.png";
import test from "../../images/test-manager.png";
import configration from "../../images/configration.png";

import ProgressSide from "./ProSide";
import { Link, useLocation } from "react-router-dom";

import Dropdown from '../dorpdown/Dropdown'
function TracerSidebar({handleClick, isActive}) {

  
  const { pathname } = useLocation();
  const [selected, setSelected] = useState("Active");
  // const togglebtn = (index) => {
  //   setToggleSta(index);
  // };

  return (
    <>
      <div className={isActive ? "isActive" : "sidebar"}>
        <div className="logo-menu">
          <div className="logo">
            <Link to="/">
              <img src={Logo} className="logo-lg" alt="" />
              <img src={Logosm} className="logo-sm" alt="" />{" "}
            </Link>
          </div>
          <div className="menubar" onClick={()=> handleClick()}>
            <img src={Menu} alt="" />
          </div>
        </div>
        <div className="sidebar-menu">
          <div className="sidebtn">
            <div className="side-btn1 btnside">
              <Link to="/trs">
                <div
                  className={pathname === "/trs" ? "btn1 active-btn1" : "btn1"}
                  // onClick={() => togglebtn(1)}
                >
                  <img src={test} alt="" /> TEST MANAGER
                </div>
              </Link>
              <Link to="/portalConsole">
                {" "}
                <div
                  className={
                    pathname === "/portalConsole" ? "btn1 active-btn2" : "btn2"
                  }
                  // onClick={() => togglebtn(2)}
                >
                  {" "}
                  <img src={SearchIcon} alt="" /> Console
                </div>
              </Link>
            </div>
            <div className="side-btn1">
              <Link to="/portalCTQ">
                <div
                  className={
                    pathname === "/portalCTQ" ? "btn1 active-btn3" : "btn1"
                  }
                  // onClick={() => togglebtn(3)}
                >
                  <img src={CTQ} alt="" /> CTQ
                </div>
              </Link>
              <Link to="/ConfigMain">
                <div
             className={pathname === "/ConfigMain" ? "btn1 active-btn4" : "btn1"}
                  // onClick={() => togglebtn(4)}
                >
                  <img src={configration} alt="" /> configuration
                </div>
              </Link>
            </div>
          </div>

          <div className="filter">
            <h5>Filter</h5>
          </div>
          <div className="select">
            <Dropdown selected={selected} setSelected={setSelected}/>
            <div className="prograss-bar lb1">
              <div className="label ">
                <label htmlFor="">Belt jig 6</label>
                <label htmlFor="">82%</label>
              </div>
              <div className="pro-br progres-bar1"  >
                <ProgressSide done={82} />
              </div>
            </div>
            <div className="prograss-bar slect">
              <div className="label ">
                <label htmlFor="">Belt jig 2</label>
                <label htmlFor="">58%</label>
              </div>
              <div className="pro-br progres-bar2"  >
                <ProgressSide done={58} />
              </div>
            </div>
            <div className="prograss-bar ">
              <div className="label">
                <label htmlFor="">Belt jig 5</label>
                <label htmlFor="">20%</label>
              </div>
              <div className="pro-br progres-bar3"  >
                <ProgressSide done={20} />
              </div>
            </div>
            <div className="prograss-bar">
              <div className="label">
                <label htmlFor="">Belt jig 4</label>
                <label htmlFor="">100%</label>
              </div>
              <div className="pro-br progres-bar4"  >
                <ProgressSide done={100} />
              </div>
            </div>
            <div className="prograss-bar">
              <div className="label">
                <label htmlFor="">Belt jig 1</label>
                <label htmlFor="">E 30</label>
              </div>
              <div className="pro-br progres-bar5"  >
                <ProgressSide done={70} />
              </div>
            </div>
          </div>
        </div>
      </div>
      
    </>
  );
}

export default TracerSidebar;
